import React from 'react';

import { ChartPie } from '@bringg-frontend/chart-pie';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { formatFloatAsPercent } from '@bringg-frontend/utils';

import styles from './chart-pei-section.module.scss';

interface ChartPeiSectionProps {
	reservedCapacityRatio: number;
	fillRatio: number;
	totalSlotSeconds: number;
	assignedCount: number;
	maxCount: number;
}

const ChartPeiSection = ({
	reservedCapacityRatio,
	fillRatio,
	totalSlotSeconds,
	assignedCount,
	maxCount
}: ChartPeiSectionProps) => {
	const { t } = useTranslation();
	const utilizedPercent = formatFloatAsPercent(fillRatio);
	const reservedPercent = formatFloatAsPercent(reservedCapacityRatio);

	return (
		<div className={styles.wrapper}>
			<span className={styles.title}>
				{`${t('PLANNED_DELIVERY_WINDOWS_POPOVER_CONTENT.CHART_PIE.FULFILMENT_STATUS')}`}:
			</span>
			<div className={styles.container}>
				<div className={styles.leftSide}>
					<span className={styles.ordersCount}>
						{assignedCount}
						{maxCount > 0 ? `/${maxCount}` : null}
					</span>
					<span className={styles.ordersLbel}>
						{`${t('PLANNED_DELIVERY_WINDOWS_POPOVER_CONTENT.CHART_PIE.ORDERS')}`}
					</span>
				</div>
				<div className={styles.pipDivider} />
				<div className={styles.chart}>
					<ChartPie
						plannedSeconds={fillRatio * totalSlotSeconds}
						reservedCapacityRatio={reservedCapacityRatio}
						availableSeconds={totalSlotSeconds}
					/>
				</div>

				<div
					className={classnames(styles.content, { [styles['content-no-reserved']]: !reservedCapacityRatio })}
				>
					<div className={styles.topSection}>
						<span className={styles.utilizedValue}>{utilizedPercent}</span>
						{reservedCapacityRatio ? (
							<span className={styles.reservedText}>
								+ {reservedPercent}{' '}
								{`${t('PLANNED_DELIVERY_WINDOWS_POPOVER_CONTENT.CHART_PIE.RESERVED_CAPACITY')}`}
							</span>
						) : (
							<span className={styles['slot-utilization-text']}>
								{`${t('PLANNED_DELIVERY_WINDOWS_POPOVER_CONTENT.CHART_PIE.SLOT_UTILIZATION')}`}
							</span>
						)}
					</div>
					{!!reservedCapacityRatio && (
						<div className={styles.bottomSection}>
							<span className={styles.infoText}>
								{t('PLANNED_DELIVERY_WINDOWS_POPOVER_CONTENT.CHART_PIE.CONFIGURATION_MESSAGE')}
							</span>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default ChartPeiSection;
